import styled from 'styled-components';

export const StyledFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
`;

export const Title = styled.p`
  font-weight: 500;
  text-transform: uppercase;
`;

export const Container = styled.div`
  text-align: left;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  font-weight: 500;
  .notification-container {
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    margin-top: 3px;
  }
`;
